/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './SkipNavLink.style';

import messages from 'src/shared/app/nav/l10n/navigationL10n';
import { mainContentId } from 'src/shared/app/nav/settings/navSettings';

const useStyles = createUseStyles(styles);

const SkipNavLink = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <a className={classes.root} href={`#${mainContentId}`}>
      {intl.formatMessage(messages.skip)}
    </a>
  );
};

export default compose(React.memo)(SkipNavLink);
